import { classNames } from "../utils";

const Divider = ({
  addMargin = true,
  className,
}: {
  addMargin?: boolean;
  className?: string;
}) => {
  return (
    <span
      className={classNames(
        "block w-full h-[0.5px] bg-gray-300",
        addMargin ? "mt-6" : "",
        className ?? ""
      )}
    ></span>
  );
};

export default Divider;
